const DefaultState = {
  loading: false,
  orders: [],
  errorMsg: "",
};

export const soReducer = (state = DefaultState, action) => {
  switch (action.type) {
    case "GET_SO_LOADING":
      return {
        ...state,
        loading: true,
        errorMsg: "",
      };
    case "GET_SO_FAIL":
      return {
        ...state,
        loading: false,
        errorMsg: "Eror Loading SO",
      };
    case "GET_SO_SUCCESS":
      return {
        ...state,
        loading: false,
        orders: action.payload,
        errMsg: "",
      };

    default:
      return state;
  }
};
